import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import type { TicketedEvent } from 'hb-react/shared/apps/Events';

export const useIsLoginRequired = (
  event: Pick<TicketedEvent, 'registration_status' | 'tickets'>,
) => {
  const { currentUser } = useDefaultAppContexts();

  return (
    !currentUser &&
    (event.registration_status !== 'open' ||
      event.tickets.every(({ internal_ticket: should }) => should))
  );
};
